import firebase from "firebase";
import axios from 'axios'
import swal from 'sweetalert2'

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

export default {

  request(method, originUrl, params) {
    let promise = null
    const url = process.env.API_URL + originUrl

    // ログイン時はIDトークンなし
    if (originUrl.indexOf('login') !== -1) {
      promise = axios({
        method: 'POST',
        url: url,
        data: params,
      })
      promise.catch(() => {
        return swal({
          text: 'エラーが発生しました',
          type: 'error'
        })
      })
      return promise
    }

    // クエリパラメータのユーザIDは不要
    if (method === 'get') delete params.user_id

    return firebase.auth().currentUser.getIdToken(/* forceRefresh */ true).then(function(idToken) {
      if (method === 'get') {
        promise = axios({
          method: 'GET',
          url: url,
          params: params,
          headers: { 'Authorization': 'Bearer ' + idToken },
        })
      } else if (method === 'post') {
        promise = axios({
          method: 'POST',
          url: url,
          data: params,
          headers: { 'Authorization': 'Bearer ' + idToken },
        })
      } else if (method === 'put') {
        promise = axios({
          method: 'PUT',
          url: url,
          data: params,
          headers: { 'Authorization': 'Bearer ' + idToken },
        })
      }
      promise.catch(() => {
        return swal({
          text: 'エラーが発生しました',
          type: 'error'
        })
      })
      return promise
    })
  },

  get(url, params) {
    return this.request('get', url, params)
  },

  post(url, params) {
    return this.request('post', url, params)
  },

  put(url, params) {
    return this.request('put', url, params)
  }
}



// WEBPACK FOOTER //
// ./src/vuex/api/api.js